import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { ApplicationConfig, inject, provideZoneChangeDetection } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideGroundworksAuth } from "@groundworks/ngx-groundworks-auth";
import { routes } from "./app.routes";
import { buildGroundworksAuthConfig, resolveApiUrl } from "./auth.config";
import { API_BASE_URL } from "./sdk/sdk";
import { ConfigService } from "./services/config.service";

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    ConfigService,
    {
      provide: API_BASE_URL,
      useFactory: () => resolveApiUrl(inject(ConfigService))
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideGroundworksAuth(() => buildGroundworksAuthConfig(inject(ConfigService))),
  ]
};
